<div class="loading-spinner" *ngIf="loadingIcon" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div *ngIf="!ChangePlan">
    <div class="row">
        <div class="col-24">
            <label>Search Group plans with any of following filter criteria:</label>
        </div>
    </div>
    <div class="row">
        <div class="col-24">

        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="input-wrapper">
                <ValidatedTextField class=""
                                    [label]="'Carrier'"
                                    [id]="primary-carrier"
                                    [maxlength]="20"
                                    [text]="groupPlanFilterData.Carrier"
                                    (onValueChange)="groupPlanFilterData.Carrier = $event">
                </ValidatedTextField>
                <div class="red-text">
                    {{lengthErrorC}}
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="input-wrapper">
                <ValidatedTextField class=""
                                    [label]="'Account'"
                                    [id]="account"
                                    [maxlength]="20"
                                    [text]="groupPlanFilterData.Account"
                                    (onValueChange)="groupPlanFilterData.Account = $event">
                </ValidatedTextField>
                <div class="red-text">
                    {{lengthErrorA}}
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="input-wrapper">
                <ValidatedTextField class=""
                                    [label]="'Group'"
                                    [id]="group"
                                    [maxlength]="20"
                                    [text]="groupPlanFilterData.Group"
                                    (onValueChange)="groupPlanFilterData.Group = $event">
                </ValidatedTextField>
                <div class="red-text">
                    {{lengthErrorG}}
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="input-wrapper">
                <ValidatedTextField class=""
                                    [label]="'CUID'"
                                    [id]="cuid"
                                    [maxlength]="20"
                                    [text]="groupPlanFilterData.CUID"
                                    (onValueChange)="groupPlanFilterData.CUID = $event">
                </ValidatedTextField>
                <div class="red-text">
                    {{lengthErrorCU}}
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <div class="red-text">
                {{errorMsg}}
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <button class="button primary" (click)="showPlans()">Show Plans</button>
        </div>
    </div>
    <div class="row">
        <div class="col-24" *ngIf="showWarning"><p class="Italic red-text Bold">Warning: Your search criteria resulted in a high volume of plans.  If your Group is not found below, please use additional filters and search again.</p></div>
    </div>
    <div class="row">
        <div class="col-24" *ngIf="noGrpPlan">
            <div>
                <jqxGrid #myGrid (onBindingcomplete)="onGridReady($event)" (onFilter)="onGridFilter($event)" (onRowselect)="myGridOnRowSelect($event)" [height]="350"
                         [width]="1110" [source]="dataAdapter" [columns]="columns" [ready]="ready" [columnsheight]="50"
                         [filterable]="true" [showfilterrow]="true" [enablekeyboardnavigation] = "true" [accessibility]="true">
                </jqxGrid>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24" *ngIf="noDataFound"><p class="red-text">No data found</p></div>
        <br />
    </div>
</div>
<div *ngIf="ChangePlan">
    <div class="row">
        <div class="col-24">
            <label>Selected Plan: {{enrollmentDrugViewModel.SINGLEGRPNAME }}</label>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <button class="button primary" (click)="ChangePlanClick()">Change Plan</button>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24"></div>
    <br />
</div>
<div #srAnnouncer
     aria-live="assertive"
     aria-atomic="true"
     class="sr-only">
</div>